<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="titleText"
    cancel-btn="Отменить"
    :success-btn="active ? 'Изменить' : 'Добавить'"
    @submit="onSubmit"
    @closed="$emit('closed')"
  >
    <v-row dense>
      <v-col cols="6">
        <BAutocompleteSelect
          v-model="form.sheet_uuid"
          label="Страница"
          validate="required"
          no-data-text="Страница не найдена"
          :options="optionSheets"
          :return-object="false"
          :disabled="optionSheets.length < 2"
          item-text="name"
          item-value="uuid"
          @input="form.cell_uuid = null"
        >
          <template #item="{ item }">
            <span>{{ item.name }}</span>
            <span class="caption text--secondary ml-2">
              ({{ item.code }})
            </span>
          </template>
        </BAutocompleteSelect>
      </v-col>

      <v-col cols="6">
        <BAutocompleteSelect
          :key="form.sheet_uuid"
          v-model="form.cell_uuid"
          validate="required"
          label="Ячейка"
          no-data-text="Ячейка не найдена"
          :options="optionCells"
          :return-object="false"
          :disabled="!form.sheet_uuid"
          item-text="name"
          item-value="uuid"
          :autofocus="!form.cell_uuid"
          :exclude="[currentCell]"
          :multiple="!cell_uuid"
        >
          <template #item="{ item }">
            <span>{{ item.name }}</span>
            <span class="caption text--secondary ml-2">
              ({{ item.code }})
            </span>
          </template>
        </BAutocompleteSelect>
      </v-col>
    </v-row>
  </BModalConfirm>
</template>

<script>
import { FILE_TAG_LINK } from '@/helpers/enums/params'
import { SETTINGS } from './utils'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BAutocompleteSelect from '@/components/forms/BAutocompleteCommon/BAutocompleteSelect.vue'


const createDefaultData = (params) => {
  const { cell_uuid, currentSheet, selectedSheet } = params

  return {
    sheet_uuid: selectedSheet ? selectedSheet.$parent.uuid : currentSheet.uuid,
    cell_uuid,
  }
}

export default {
  name: 'BEditorModalExcelCell',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BModalConfirm,
    BAutocompleteSelect,
  },
  inheritAttrs: false,
  props: {
    cell_uuid: String,
    currentSheet: {
      type: Object,
      required: true,
    },
    currentCell: {
      type: Object,
      required: true,
    },
    sheetTree: {
      type: Object,
      required: true,
      validator: (prop) => '$children' in prop,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  tag: FILE_TAG_LINK,
  data: (vm) => {
    const selectedSheet = vm.cell_uuid && vm.sheetTree.$children
      .find((sheet) => sheet.uuid === vm.cell_uuid)

    const options = {
      ...vm.$props,
      selectedSheet,
    }

    return {
      form: createDefaultData(options),
    }
  },
  computed: {
    titleText() {
      return this.active ? SETTINGS.excel_cell[2] : SETTINGS.excel_cell[1]
    },
    selectedSheet() {
      const uuid = this.form.sheet_uuid
      return this.sheetTree.$children.find((sheet) => sheet.uuid === uuid)
    },
    optionSheets() {
      return this.sheetTree.$children
    },
    optionCells() {
      return this.selectedSheet?.$children
    },
  },
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(flag) {
      return this.$refs.modal.close(flag)
    },
    async onSubmit() {
      const result = await this.$validator.validate()
      if (!result) return
      this.close(this.form)
    },
  },
}
</script>
